import InstanceApi from "@/services/apiClient.js";
import { mapGetters, mapActions } from "vuex";
import EventBus from "@/event-bus";

export default {
  computed: {
    ...mapGetters({ storeUrlPrefix: "getStoreUrlPrefix" }),
  },
  methods: {
    ...mapActions(["updateCurrentCartRecaps", "removeCurrentCartRecaps"]),

    async removeItemToCart(itemId, isOption, isProductId, updatePrice = true) {
      try {
        EventBus.$emit('toggleLoader')
        let apiUrlDeleteOptionToCart = "mcp/cart/delete/id/" + itemId;
        if(typeof isProductId != 'undefined') {
            apiUrlDeleteOptionToCart += '/isProductId/1';
        }
        const response = await InstanceApi.get(apiUrlDeleteOptionToCart);
        EventBus.$emit('toggleLoader')
        if (response.status && response.status === 200 && isOption) {
          if(updatePrice) {
            this.updateCurrentCartRecaps(response.data);
          }
        } else {
          location.reload();
        }
      } catch (error) {
        EventBus.$emit('toggleLoader')
        this.$fire({
          title: "Oups",
          text: "Une erreur est survenu lors de la supression de l'item du panier",
          type: "error",
          timer: 1500,
          position: "top-end",
        });
      }
    },
  },
};
